import styled from 'styled-components';

import { AnimatedSearchSuggestions } from 'search/components/search/AnimatedSearchSuggestions';
import { DESKTOP_BANNER_HEIGHT } from 'banner/enums/constants';
import { SearchBox } from 'search/components/search/SearchBox';
import { fadeIn, variableFont } from 'styles/theme';
import { useKeyDown } from 'shared/hooks/useKeyDown';
import { useOnRouteChangeComplete } from 'shared/hooks/useOnRouteChangeComplete';
import { useOutsideClick } from 'shared/hooks/useOutsideClick';
import { useState } from 'react';
import { t } from 'localization/utils/t';

const TP = 'search.components.search.SearchBarDesktop';

export const SearchBarDesktop = ({
  isBannerVisible,
  suggestedSearches,
  error,
}: {
  isBannerVisible: boolean;
  suggestedSearches?: any[];
  error?: Error;
}) => {
  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);

  const openSearchBox = () => setIsSearchBoxOpen(true);
  const closeSearchBox = () => setIsSearchBoxOpen(false);
  const searchBoxRef = useOutsideClick(closeSearchBox);

  useKeyDown('Escape', closeSearchBox);
  useOnRouteChangeComplete(closeSearchBox);

  if (!isSearchBoxOpen) {
    return (
      <SearchBarDesktop.Placeholder onClick={openSearchBox} data-qa="search_placeholder">
        <SearchBarDesktop.SearchPlaceholder>
          {t(`${TP}.search`, 'Search')}
        </SearchBarDesktop.SearchPlaceholder>
        <AnimatedSearchSuggestions suggestedSearches={suggestedSearches} />
      </SearchBarDesktop.Placeholder>
    );
  }

  return (
    <SearchBarDesktop.Wrapper ref={searchBoxRef} $isBannerVisible={isBannerVisible}>
      <SearchBox suggestedSearches={suggestedSearches} error={error} />
    </SearchBarDesktop.Wrapper>
  );
};

SearchBarDesktop.Placeholder = styled.button`
  display: flex;
  padding: 12px 0;
  cursor: text;
  white-space: nowrap;
  text-align: left;
  ${variableFont({ size: '11.5px', height: '14px', fontWeight: '300' })};
`;

SearchBarDesktop.SearchPlaceholder = styled.span`
  z-index: ${({ theme }) => theme.zIndex.searchPlaceholder};
`;

SearchBarDesktop.Wrapper = styled.div<{ $isBannerVisible: boolean }>`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.navigation.searchBorderColor};
  color: ${({ theme }) => theme.colors.black};
  top: ${({ $isBannerVisible }) =>
    $isBannerVisible ? `calc(${DESKTOP_BANNER_HEIGHT} + 12px)` : '12px'};
  width: 375px;
  z-index: ${({ theme }) => theme.zIndex.dropdownSelectMenu};
  ${fadeIn};
`;
